export async function downloadAsync(url, _hash, _type) {
    return url;
}

//# sourceMappingURL=ExpoAsset.web.js.map
